<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">Event Organizers List</h2>
      <base-button
        type="primary"
        round
        icon
        class="top-button"
        @click="$router.push('add?id=-1')"
      >
        <i class="fa fa-plus"></i>
      </base-button>
    </div>
    <!--  <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">City List</h2>
    </div> -->
    <div class="row mt-2">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title"></h4>
          <div>
            <!-- <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div> -->
            <el-table :data="queriedData">
              <el-table-column :min-width="200" align="left" label="Email">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.username }}</div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="200"
                align="left"
                label="Display Name"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.displayname }}</div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Events">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        {{
                          props.row.assignedEvents
                            .map(e => e.event_name)
                            .join(",")
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <!-- <el-table-column
                :min-width="200"
                align="left"
                label="Add Event"
                v-if="role == 'Admin'"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <button
                        class="btn btn-fill"
                        @click="$router.push('event?id=' + props.row._id)"
                      >
                        Add Events
                      </button>
                    </div>
                  </div>
                </div>
              </el-table-column> -->

              <el-table-column :min-width="200" align="left" label="Action">
                <div style="display: flex" slot-scope="props">
                  <div>
                    <a>
                      <i
                        class="fas fa-edit"
                        @click="$router.push('add?id=' + props.row._id)"
                        style="color: white; cursor:pointer"
                      ></i>
                    </a>
                  </div>

                  <div style="margin-left: 15%">
                    <a v-on:click="DeletePass(props.row._id)">
                      <i
                        class="fas fa-trash"
                        style="color: #ff0d0d; cursor:pointer"
                      ></i>
                    </a>
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <!-- {{props.row.displayname}} -->
          </div>
          <!-- <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div> -->
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      console.log("hello");
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        console.log(this.searchedData);
        console.log("search data ");
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },

  data() {
    return {
      role: "",
      loading: true,
      noDataMessage: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["username"],
      tableColumns: [
        {
          prop: "username",
          label: "User Name",
          minWidth: 200
        },

        {
          prop: "displayname",
          label: "Display Name",
          minWidth: 200
        },

        {
          prop: "role",
          label: "Events",
          minWidth: 200
        }
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {}
    };
  },
  async mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["username", "displayname", "events"],
      threshold: 0.3
    });

    this.loading = true;

    let admin = await this.$apiService.postCall("admin/getAllAdmin");

    console.log("Admin Data");
    console.log(admin);
    this.tableDatas = admin.apidata.Data || [];
    this.tableData = this.tableDatas.reverse();
    console.log(this.tableData);
    this.loading = false;

    this.role = window.localStorage.getItem("role");
  },
  methods: {
    async DeletePass(id) {
      debugger;

      var del = confirm("Do You Really Want To Delete");
      if (del) {
        // const id = this.$route.query.id;

        const del_pas = await this.$apiService.postCall(
          "admin/deleteAdmin/",
          { _id: id },
          console.log("ss")
        );

        setTimeout(() => {
          window.location.reload();
        }, 1000);
        this.$apiService.notify("Event Organizer has been deleted");
        // window.location.reload();
        // this.$router.push("/organizers/list");
      }
    }
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      console.log("search ");
      console.log(value);
      console.log(this.searchQuery);
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
